<template>
  <div>
    <v-row no-gutters justify="start">
      <div class="side-content-small ml-6">
        <v-row no-gutters align="center" class="content-header">
          <v-icon class="mr-3 pb-1">domain</v-icon>
          <div class="font-weight-bold">
            {{ company.name }}
          </div>
        </v-row>
        <div class="left-admin-nav">
          <ul>
            <li
              v-for="(tab, i) in tabs"
              :key="i"
              :class="{ active: tab.isActive }"
              @click="goTo(tab.path)"
            >
              <v-icon class="float-right">keyboard_arrow_right</v-icon>
              <div>{{ tab.text }}</div>
            </li>
          </ul>
        </div>
      </div>
      <v-col align="center" class="pa-0 mx-6">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: `SettingsMainLayout`,
  data: () => ({
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
      `isSelfMaker`,
    ]),
    ...mapState(`ui/settings`, [
      `rootTabs`,
      `aggregatorTabs`,
    ]),
    storeTabs() {
      return this.company.isRoot ? this.rootTabs : this.aggregatorTabs;
    },
    tabs() {
      return _.chain(this.storeTabs)
        .filter(tab =>
          tab.onlyForSelfMakers !== true || this.isSelfMaker
        )
        .map(tab => ({
          ...tab,
          isActive: this.$route.path === tab.path,
        }))
        .value();
    },
  },
  methods: {
    goTo(path) {
      if (path !== this.$route.path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="scss">
</style>
